/* eslint-disable react-hooks/exhaustive-deps */
import styles from './UnsupportedBrowser.module.css';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Background, Navbar } from 'layout';
import { Image, Loader } from 'ui';
import Card from 'react-bootstrap/Card';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { selectProfile } from 'store/common/selectors/profile';
import { setCompanyDetails } from 'store/common/slices/profile';
import { profileApis } from 'api/profile';

const UnsupportedBrowser = ({ image, heading, children }) => {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const session = useSelector((state) => state.session);

    useEffect(() => {
        if (_.isEmpty(session)) {
            dispatch(
                setCompanyDetails({
                    company: {
                        name: 'Authenticating.com',
                    },
                })
            );
        } else {
            session &&
                session.token &&
                !profile.loading &&
                dispatch(
                    profileApis.endpoints.getProfile.initiate(undefined, {
                        forceRefetch: true,
                        subscribe: false,
                    })
                );
        }
    }, []);
    return (
        <>
            <Navbar />
            <Background className={styles.notFoundWrapper}>
                {profile.loading ? (
                    <div className={styles.loaderWrapper}>
                        <Loader />
                    </div>
                ) : (
                    <>
                        <Card.Body className={styles.body}>
                            <Image className={styles.image} name={image} />
                            <br />
                            <h5>{heading}</h5>
                        </Card.Body>
                        {children}
                    </>
                )}
            </Background>
        </>
    );
};

UnsupportedBrowser.propTypes = {
    image: PropTypes.string,
    heading: PropTypes.string,
    children: PropTypes.node,
};

export default UnsupportedBrowser;
